export default __webpack_public_path__ + "static/media/cs-a009-3.466d870f.svg";